import { CheckCircle, SvgIconComponent, Warning } from "@mui/icons-material";
import { ActionPlanStatus } from "@mutiny-group/sbo-openapi-client";

type ActionPlanStatusStyle = {
  color: string;
  backgroundColor?: string;
  icon?: SvgIconComponent;
};

export const ActionPlanStatusMapping: Record<
  ActionPlanStatus,
  {
    label: string;
    style: ActionPlanStatusStyle;
  }
> = {
  [ActionPlanStatus.OnTrack]: {
    label: "On Track",
    style: {
      backgroundColor: "#E9F8F0",
      color: "#00A953",
      icon: CheckCircle,
    },
  },
  [ActionPlanStatus.AtRisk]: {
    label: "At Risk",
    style: {
      backgroundColor: "#FCE5C4",
      color: "#FC9429",
      icon: Warning,
    },
  },
  [ActionPlanStatus.OffTrack]: {
    label: "Off Track",
    style: {
      backgroundColor: "#FAD9D7",
      color: "#EF3D3A",
      icon: Warning,
    },
  },
  [ActionPlanStatus.Complete]: {
    label: "Complete",
    style: {
      color: "#00A953",
      icon: CheckCircle,
    },
  },
};

export const getActionPlanStatusText = (status: ActionPlanStatus, value: string) => {
  switch (status) {
    case ActionPlanStatus.OnTrack:
      return "Projected revenue is in line with the originally forecast. You are currently projected to hit or exceed your revenue goal if you continue following your scenario spending plan.";
    case ActionPlanStatus.OffTrack:
      return `Projected revenue is ${value} less than originally forecast. It is very unlikely that you will hit your revenue goal without adjusting your spend strategy. View recommendations below for plans to get back on track.`;
    case ActionPlanStatus.AtRisk:
      return `Projected revenue is ${value} less than originally forecast. Your revenue goal is still within your initial confidence interval, but you may not achieve it without changes to your spend strategy. View recommendations below for plans to get back on track.`;
    default:
      return "";
  }
};
